import React from "react"
import { Outlet, useParams } from "react-router-dom"
import { LoaderInline } from "src/components/global/LoaderInline"
import { ModuleErrors } from "src/components/ui/ModuleErrors"
import { useActions, useAppState } from "src/state"

export function AgencyOperationsAdminVenueAreaLayout() {

    const { areaId } = useParams()

    const { loading, currentItem, errors } = useAppState().areas
    const { subscribeToItem, unsubscribeFromItem } = useActions().areas

    React.useEffect(() => {
        subscribeToItem({ id: areaId });
        return () => {
            unsubscribeFromItem()
        }
    }, [areaId, subscribeToItem, unsubscribeFromItem])

    if (loading||!currentItem) return <LoaderInline />

    return (
        <React.Fragment>
            <ModuleErrors errors={errors} />
            <Outlet/>
        </React.Fragment>
    )

}